<template>
  <router-link :to="fields.namedRoute">
    <div
      class="card-emendas bg form-group"
      :style="{
        backgroundImage:
          'url(' + require(`@/assets/css/img/${fields.icon}`) + ')'
      }"
    >
      <div class="context">
        <span class="title">{{ fields.nome }}</span>
        <span>{{ formatarMoeda(fields.valor) }}</span>
      </div>
    </div>
  </router-link>
</template>

<script>
import { formatarMoeda } from '@/utils'

export default {
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      default: {
        namedRoute: '#',
        nome: 'titulo',
        icon: 'ico-servidor.svg',
        valor: 0
      }
    }
  },
  methods: {
    formatarMoeda
  },
  computed: {
    fields() {
      return {
        ...this.default,
        ...this.item
      }
    }
  }
}
</script>

<style scoped>
.card-emendas {
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-radius: 5px;
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 1px 1px 10px 1px;
  transition: all ease 200ms;
  background-repeat: no-repeat;
  background-size: 80% 80%;
  background-position: center;
  opacity: 0.5;
  font-size: 1.6em;
}

a:hover .card-emendas {
  box-shadow: 0 4px 5px 2px #e8e8e8, 0 2px 1px 1px #d8d8d8;
  transform: translateY(-4px);
}

.card-emendas .context {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.9);
  text-transform: uppercase;
  text-align: center;
}

.card-emendas .context .title {
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/CardEmendas/index.vue